/**
 * Имена RBAC-прав, синхронизированные с бэкендом
 * (см. `uz.beantech.p2ploans.rbac.Permissions`).
 *
 * Используются в `accessControlProvider` и хуке `usePermission`.
 * При добавлении нового права на бэке — синхронизировать здесь.
 */
export const Permissions = {
  ADMIN_ACCESS: 'admin.access',
  PROFILE_READ: 'profile.read',
  PROFILE_WRITE: 'profile.write',
  DEVICE_READ: 'device.read',
  DEVICE_REVOKE: 'device.revoke',
  SETTINGS_READ: 'settings.read',
  SETTINGS_WRITE: 'settings.write',
  USERS_READ: 'users.read',
  USERS_MANAGE: 'users.manage',
  USERS_ROLES_WRITE: 'users.roles.write',
  ROLES_READ: 'roles.read',
  ROLES_WRITE: 'roles.write',
  PERMISSIONS_READ: 'permissions.read',
  AGREEMENT_READ_ALL: 'agreement.read.all',
  AUDIT_READ: 'audit.read',
  DISPUTE_EVIDENCE_EXPORT: 'dispute.evidence.export',
} as const;

/**
 * Объединение строковых имён всех известных прав. Уже валидирует на этапе
 * компиляции, что в коде нельзя сослаться на несуществующее право.
 */
export type PermissionName = (typeof Permissions)[keyof typeof Permissions];
